import { Method } from 'axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class UnshareAlbumAPICall extends APICallV4 {
    _method = 'album/unshare';
    _type: Method = 'post';
}
